import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { UPDATE_QUESTION } from '../../features/State Management/questionsSlice'
import store from '../../store'
import { CLEAN_SUPER_QUESTION } from '../../utils'
import { postprocessQuestion } from '../../utils/postprocessor'
import { TitleProperty } from '../Atoms/Properties/TextProperties'
import { setQuestion } from '../../features/State Management/questionSlice'

/**
 * In general, this is a stripped down version of the edit dialog, containing one property: title.
 * */
const EditQuestionTitleField = ({ question, onComplete }) => {
  const dispatch = useDispatch()
  useEffect(() => {
    function handleKeyDown(event) {
      // noinspection FallThroughInSwitchStatementJS
      switch (event.code) {
        case 'Enter':
          updateTitle(event)
        // eslint-disable-next-line no-fallthrough
        case 'Escape':
          onComplete()
        // eslint-disable-next-line no-fallthrough
        default:
          break
      }
    }

    function updateTitle(event) {
      event.preventDefault()

      const state = store.getState()
      const newQuestion = postprocessQuestion(state.question)
      dispatch(UPDATE_QUESTION({ id: question.id, new: newQuestion }))
    }

    document.addEventListener('keydown', handleKeyDown)
    dispatch(setQuestion({ ...CLEAN_SUPER_QUESTION, ...question }))

    // Very important to do cleanup, otherwise the event listeners will pile up and we'll trigger multiple updates
    // per event, which will mess up the state
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [dispatch, onComplete, question])

  return <TitleProperty key={question.id} />
}
export default EditQuestionTitleField
